import Layout from '@/components/feature/Layout';
import useSeo from '@/hooks/useSeo';
import { siteConfig } from '@/mocks/site';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import HotArticles from './components/HotArticles';
import CategoryShowcase from './components/CategoryShowcase';
import FaqPreview from './components/FaqPreview';
import CtaBanner from './components/CtaBanner';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteConfig.name,
  description: siteConfig.description,
};

export default function Home() {
  useSeo({
    title: '洞洞杂货铺漫画 - 洞洞杂货铺漫画是什么 / 世界观与故事背景设定解析',
    description: siteConfig.description,
    keywords: siteConfig.keywords,
    jsonLd,
  });

  return (
    <Layout>
      <Hero />
      <Introduction />
      <HotArticles />
      <CategoryShowcase />
      <FaqPreview />
      <CtaBanner />
    </Layout>
  );
}